var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18V13H2V16H5V18H0ZM17 18V16H20V13H22V18H17ZM3 15V3H5V15H3ZM6 15V3H7V15H6ZM9 15V3H11V15H9ZM12 15V3H15V15H12ZM16 15V3H17V15H16ZM18 15V3H19V15H18ZM0 5V0H5V2H2V5H0ZM20 5V2H17V0H22V5H20Z",
    fill: "#087E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanGreen);
export default __webpack_public_path__ + "static/media/scan-green.91ffeafaa6c6d35d721e8d671b45653b.svg";
export { ForwardRef as ReactComponent };